import { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle`


@font-face {
font-family: "Pretendard";
font-weight: 900;
font-display: swap;
src: local("Pretendard Black"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Black.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Black.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Black.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 800;
  font-display: swap;
  src: local("Pretendard ExtraBold"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-ExtraBold.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-ExtraBold.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-ExtraBold.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 700;
  font-display: swap;
  src: local("Pretendard Bold"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Bold.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Bold.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Bold.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 600;
  font-display: swap;
  src: local("Pretendard SemiBold"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-SemiBold.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-SemiBold.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-SemiBold.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 500;
  font-display: swap;
  src: local("Pretendard Medium"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Medium.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Medium.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Medium.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 400;
  font-display: swap;
  src: local("Pretendard Regular"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Regular.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Regular.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 300;
  font-display: swap;
  src: local("Pretendard Light"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Light.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Light.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Light.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 200;
  font-display: swap;
  src: local("Pretendard ExtraLight"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-ExtraLight.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-ExtraLight.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-ExtraLight.ttf") format("truetype");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 100;
  font-display: swap;
  src: local("Pretendard Thin"),
    url("../public/assets/fonts/pretendard/woff2/Pretendard-Thin.woff2") format("woff2"),
    url("../public/assets/fonts/pretendard/woff/Pretendard-Thin.woff") format("woff"),
    url("../public/assets/fonts/pretendard/ttf/Pretendard-Thin.ttf") format("truetype");
}


@font-face {
  font-family: "Leferi";
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  src: local('GmarketSansTTFMedium'), local('GmarketSansTTFMedium');
  src: url("../public/assets/fonts/leferi-base-bold/LeferiBaseRegular.ttf") format("truetype");
}

html, body{
    font-family: "Pretendard", sans-serif;
    font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Pretendard", Pretendard, Roboto, "Noto Sans KR", "Segoe UI", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
    font-family: "Pretendard", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}


button, div {
  font-family: inherit;
}

`;
